import React, {useState, useEffect, useContext} from 'react';
import CommandsContext from '../../../../context/commandsContext';
import useKeyPress from '../../../../hooks/useKeyPress';
import FullBodyContentView from '../../../views/fullBodyContentView';

function DefaultFlow({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;
    onExit();
  }, [leftPress]);

  useEffect(() => {
    setTimeout(() => {
      onUpdateCommands({onLeft: onExit});
    });
  }, [onExit]);

  return (
    <FullBodyContentView
      title="Default Flow Factor"
      fullCaption="None..............................0.0f............. 
      .........................................................
      .........................................................
      .........................................................
      .........................................................
      .........................................................
      "
    />
  );
}

export default DefaultFlow;
